import { render, staticRenderFns } from "./KeyValueInput.vue?vue&type=template&id=37ab0ca0&"
import script from "./KeyValueInput.vue?vue&type=script&lang=js&"
export * from "./KeyValueInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports